import React from "react";
import { Page, FormGroup, required, SubmitButton } from "components/common";
import { LocalForm, Control, actions } from "react-redux-form";
import { isEmail } from "validator";
import { Alert, Button, UncontrolledCollapse, Card, CardBody } from "reactstrap";
import { compose, withHandlers, withStateHandlers } from "recompose";
import { Trans } from "react-i18next";

const faq = [
    {
        question: "What is Hesaab?",
        answer: <span><Trans>It is a program designed to integrate with the Xero accounting software and read data in multiple languages, in addition to the HR & payroll system and electronic invoicing.</Trans></span>
    },
    {
        question: "How does Hesaab work?",
        answer: <span><Trans>Easy steps to use the platform once Hesaab program with Xero accounting software.</Trans></span>
    },
    {
        question: "How is Hesaab program linked with Xero?",
        answer: <span><Trans>Go to steps to connect Xero tab.</Trans></span>
    },
    {
        question: "How much does it cost to subscribe to Hesaab program?",
        answer: <span><Trans>Packages can be viewed through Hesaab program website</Trans> <a href="https://hesaab.app">https://hesaab.app.</a></span>
    },
    {
        question: "How can I subscribe to Hesaab program?",
        answer: <span><Trans>You can subscribe directly through the website</Trans> <a href="https://hesaab.app">https://hesaab.app.</a></span>
    },
    {
        question: "How does it work with Xero?",
        answer: <span><Trans>Once Xero system is linked to Hesaab program, all operations will appear.</Trans></span>
    },
    {
        question: "Is there a free trial version?",
        answer: <span><Trans>Yes, there is a free trial for a period of 7 days.</Trans></span>
    },
    {
        question: "Is there a fee for each user?",
        answer: <span><Trans>No, an unlimited number of users can be added.</Trans></span>
    },
    {
        question: "Is the account program compatible and linked with the Zakat and Tax Authority for the second phase?",
        answer: <span><Trans>Yes, hesaab program supports linking with the Zakat and Tax Authority (ZATCA).</Trans></span>
    }
];


export const FAQ = ({ }) => (
    <div className="faq">
        <h5 className=""><Trans>Frequently Asked Questions</Trans></h5>
        <p className="description text-muted pl-0">
            <Trans>Find answers to common questions about Hesaab, including features, pricing, and integration details.</Trans>
        </p>
        <div className="faq-content my-3">
            {faq.map((item, index) => (
                <div key={index} className={`border ${index !== faq.length - 1 ? "border-bottom-0" : ""}`}>
                    <Button color="link" id={`toggler${index}`} className="btn-link py-3 toggler text-left text-muted w-100 border-bottom mx-0 accordion-btn" data-toggle="collapse" >
                        <Trans> {item.question}</Trans>
                    </Button>
                    <UncontrolledCollapse toggler={`#toggler${index}`}>
                        <Card className="card shadow-none mb-0">
                            <CardBody className="">
                                {item.answer}
                            </CardBody>
                        </Card>
                    </UncontrolledCollapse>
                </div>

            ))}
        </div>
        <div className="more-support my-5 text-center">
            <h1 className="d-block"><i className="fa fa-comments text-success" aria-hidden="true"></i></h1>
            <h4><Trans>Still have questions?</Trans></h4>
            <p><Trans>You can contact our support team on </Trans><a href="mailto:xero@wpholding.com">xero@wpholding.com</a></p>
        </div>
    </div>
);

export default FAQ;
